﻿(function (angular) {
    'use strict';

    angular.module('Toyota.Directives')
        .directive("restrictToLength", ['$timeout', '$interval', function ($timeout, $interval) {
            return {
                restrict: "A",
                link: function (scope, elem, attrs) {
                    var limit = parseInt(attrs.restrictToLength);
                    var isAndroid = /android/i.test(navigator.userAgent);

                    function truncateAngularInput($el, limit) {
                        var elScope = $el.scope();
                        var ngModelExpression = $el.attr('data-ng-model');
                        var elValue = $el.val();

                        elScope.$eval(ngModelExpression + ' = "' + elValue.substring(0, limit) + '"');
                    }

                    elem.on("keydown paste", function (event) {
                        if (event.keyCode > 47 && event.keyCode < 127 || typeof event.keyCode === 'undefined') {
                            $timeout(function () {
                                if (elem.val().length >= limit) {
                                    truncateAngularInput(elem, limit);
                                    return false;
                                }
                            });

                        }
                    });

                    // In Android, uncommitted autocomplete keyboard words bypass
                    // maxlength in all browsers until you commit the word by tapping
                    // it, hitting space, exiting input focus etc.
                    //
                    // To combat this, we watch the field in realtime, and once the
                    // guest has gone over maxlength, we:
                    //
                    // 1) Truncate the field;
                    //
                    // 2) Exit focus from the field then restore focus immediately to
                    // "reset" the keyboard otherwise you get flickers of input which
                    // look like this:
                    //   maximummaximumextracharacters
                    // instead of staying like this:
                    //   maximum
                    //
                    // 3) When exiting focus, focus should be set to another (dummy)
                    // input so that the keyboard doesn't disappear momentarily.
                    //
                    // Using invokeApply = false so we're not calling digest every
                    // interval, but rather, only when a truncation is needed.
                    //
                    if (isAndroid) {
                        // 100ms: Arbitrary initial value. Doesn't perform any quicker
                        // at 16ms (60FPS) so left it at 100ms.
                        var watchValIntervalMs = 100;

                        var watchValInterval = $interval(function () {
                            if (elem.val().length > limit) {
                                var $tempInput = angular.element('<input type="text" />').css({
                                    'position': 'fixed',
                                    'top': '0',
                                    'opacity': '0',
                                    'pointer-events': 'none'
                                });
                                angular.element('body').append($tempInput);
                                truncateAngularInput(elem, limit);
                                $timeout(function () {
                                    $tempInput.focus();
                                    elem.focus();
                                    $tempInput.remove();
                                });
                            }
                        }, watchValIntervalMs, 0, false);

                        elem.on('$destroy', function () {
                            $interval.cancel(watchValInterval);
                        });
                    }
                }
            };
        }]);
})(window.angular);